import React from 'react';
import PropTypes from 'prop-types';
import GameArticleStarsStyled, {
  SVGStarStyled,
} from './GameArticleStars.styled';

const SVGStar = props => (
  <SVGStarStyled viewBox="0 0 100 125" {...props}>
    <path d="M71.9 60.9L96.5 42c1.8-1.4.9-4.3-1.4-4.4l-30.6-.8c-.7 0-1.4-.5-1.6-1.2L52.4 6.3c-.8-2.2-3.8-2.2-4.6 0L37.6 35.2c-.2.7-.9 1.2-1.6 1.2l-31.1.8c-2.3.1-3.2 3-1.4 4.4l24.3 18.7c.6.4.8 1.2.6 1.9L19.6 92c-.7 2.2 1.8 4 3.7 2.7l25.3-17.4c.6-.4 1.4-.4 2 0l25.6 17.6c1.9 1.3 4.4-.5 3.7-2.7l-8.7-29.4c-.1-.7.1-1.5.7-1.9z" />
  </SVGStarStyled>
);

const GameArticleStars = ({ stars, PB, roundResult }) => (
  <GameArticleStarsStyled
    roundResult={roundResult}
    title={PB ? 'Personal Best' : 'Game Result'}
  >
    <SVGStar star1 stars={stars} />
    <SVGStar star2 stars={stars} />
    <SVGStar star3 stars={stars} />
  </GameArticleStarsStyled>
);

export default GameArticleStars;

GameArticleStars.propTypes = {
  roundResult: PropTypes.bool,
  stars: PropTypes.oneOfType([PropTypes.func, PropTypes.number]).isRequired,
  PB: PropTypes.bool,
};

GameArticleStars.defaultProps = {
  PB: false,
  roundResult: false,
};



// WEBPACK FOOTER //
// ./src/components/atoms/GameArticleStars/GameArticleStars.js